import React, { useState, useEffect } from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import moment from 'moment';

import { useTranslator } from '../../../i18n/useTranslator';
import { SubmissionService } from '../../../services/Submissions.service';
import { ErrorService } from '../../../services/Error.service';
import { SimpleSubmission } from '../../../shared/types/SimpleSubmission';
import { SectionHeader } from '../../SectionHeader';
import { Message } from '../../Message';
import { Box } from '../../Box';
import { BoxLoader } from '../../BoxLoader';
import { List } from '../../List';
import { Link } from '../../Link';
import { DateService } from '../../../services/Date.service';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles>;

const ReviewerActiveSubmissionsScreenComponent: React.FunctionComponent<Props> = () => {
  const [serverError, setServerError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submissions, setSubmissions] = useState<Array<SimpleSubmission>>([]);
  const { t } = useTranslator();

  const listHeader = [
    {
      key: 'submissionName',
      text: t('submissionName'),
    },
    {
      key: 'author',
      text: t('author'),
    },
    {
      key: 'createdAt',
      text: t('submissionDate'),
    },
    {
      key: 'marked',
      text: t('marked'),
    },
    {
      key: 'mark',
      text: t('generalMark'),
    },  
  ];

  const mapRowsToListRows = () =>
    submissions.map((submission) => ({
      id: submission.id,
      items: [
        {
          key: 'submissionName',
          content: <Link to={`/reviewer/submissions/${submission.id}`}>{submission.competitionName}</Link>,
        },
        {
          key: 'author',
          content: `${submission.author.firstName} ${submission.author.lastName}`,
        },
        {
          key: 'createdAt',
          content: moment(submission.createdAt).format(DateService.DATE_FORMAT),
        },
        {
          key: 'marked',
          content: submission.hasReviewed ? <Check /> : <Close />,
        },
        {
          key: 'mark',
          content: submission.hasReviewed ? `${submission.mark}` : '',
        },        
      ],
    }));

  const fetchSubmissions = () => {
    (async () => {
      setServerError('');
      setLoading(true);

      try {
        const {
          data: { result },
        } = await SubmissionService.getActive();

        setSubmissions(result);
      } catch (error) {
        setServerError(ErrorService.parseError(error));
      }
      setLoading(false);
    })();
  };

  useEffect(fetchSubmissions, []);

  return (
    <div>
      <SectionHeader title={t('activeSubmissions')} />
      {serverError ? (
        <Message type={'ERROR'}>{t(serverError)}</Message>
      ) : (
        <Box>
          {loading ? (
            <BoxLoader />
          ) : submissions.length ? (
            <List headerCells={listHeader} rows={mapRowsToListRows()} />
          ) : (
            <div>{t('none')}</div>
          )}
        </Box>
      )}
    </div>
  );
};

export const ReviewerActiveSubmissionsScreen = withStyles(styles)(ReviewerActiveSubmissionsScreenComponent);
